












import { computed, defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import { buyingTypeOptionsType } from '../const';
export default defineComponent({
  name: 'TtamBuyingType',
  props: {
    value: {
      type: Number,
      required: true,
    },
    options: {
      type: Array as PropType<buyingTypeOptionsType[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _classify = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });

    return {
      _classify,
    };
  },
});
